import gql from 'graphql-tag';

export const DESTROY_PURCHASE_ORDER = gql`
	mutation destroyPurchaseOrderMutation($id: ID!) {
		destroyPurchaseOrder(id: $id)
	}
`;
